import { TApplicationState } from '../../types/redux';
import { IDocument } from '../../types/newbuilding/document';

export function getDocuments(state: TApplicationState): IDocument[] {
  const {
    newbuilding: { documentation },
  } = state;

  if (documentation && documentation.length) {
    return documentation;
  }

  return [];
}
